import { Formatter } from 'gf-ui'
import React from 'react'
import { FaChevronRight, FaEdit, FaLevelDownAlt } from 'react-icons/fa'

const Subcategorie = ({ categorie, descField="DESCRIZIONE", onSelCategoria }) => {
  return <div className='d-flex flex-row align-items-center justify-content-center flex-wrap'>{categorie && categorie.map(cat =>
    <div style={{width: '100%', maxWidth: '400px'}} className='animate__animated animate__flipInX'>
      <div className={`menu-questionario menu-item m-2 border rounded-pill px-4 bg-white d-flex flex-column align-items-start justify-content-center ${!Formatter.isStringaVuota(cat.ID_MA_MODELLO) && parseInt(cat.TOT_FIGLI) > 0 ? 'leveldown' : 'questionario'}`} onClick={() => onSelCategoria(cat)}>
        <div className="w-100 d-flex flex-row align-items-center justify-content-between">
          <span className='m-2 text-primary'><strong>{cat[descField]}</strong></span>
          <div style={{ width: '30px' }}>
            <>
              {Formatter.isStringaVuota(cat.ID_MA_MODELLO) ?
                <></>
                :
                parseInt(cat.TOT_FIGLI) === 0 ? 
                <h4 className='m-0 icona'><FaEdit color="var(--bs-primary)" /></h4>
                : 
                <></>                
              }
              <h2 className='m-0 arrow'><FaChevronRight color="var(--bs-primary)" /></h2>
              <h4 className='m-0 arrow-leveldown'><FaLevelDownAlt color="var(--bs-primary)" /></h4>
            </>
          </div>
        </div>
      </div>
    </div>    
  )}
  </div>
}

export default Subcategorie